import { computed, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ETeamTypeTap } from '../models/enums';

interface ITapOption {
  title: string;
  isSelected: boolean;
  value: ETeamTypeTap;
}

@Injectable({
  providedIn: 'root',
})
export class TeamTabsService {
  private readonly translateService = inject(TranslateService);

  //  valueTap = output<ETeamTypeTap>();
  selectedTap = signal<ETeamTypeTap>(ETeamTypeTap.MATCHES);
  tapOption = computed<ITapOption[]>(() => [
    {
      title: this.translateService.instant('Matches'),
      isSelected: true,
      value: ETeamTypeTap.MATCHES,
    },
    {
      title: this.translateService.instant('Scores'),
      isSelected: false,
      value: ETeamTypeTap.RESULTS,
    },
    {
      title: this.translateService.instant('Standing'),
      isSelected: false,
      value: ETeamTypeTap.STANDING,
    },
    {
      title: this.translateService.instant('Team'),
      isSelected: false,
      value: ETeamTypeTap.EQUIPMENT,
    },
  ]);

  displayedTapOptions = computed(() =>
    this.tapOption().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTap(),
    }))
  );

  handleSetTap = (value: ETeamTypeTap) => {
    this.selectedTap.set(value);
    //  this.valueTap.emit(value);
  };

  constructor() {}
}
